
export default class DatabaseHandler {
  constructor(
    db_name,
    db_version,
    db_tables = {},
    hooks       = null,
    settings    = null
  ) {

    console.log('DataHandler constructor...');
    this.cache    = {}
    this.db = false;
    this.db_name = db_name;
    this.db_version = db_version;
    this.db_tables = db_tables;
    //window.indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
    if (!window.indexedDB)
    {
      console.error("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
      return false;
    }
    else
    {
        console.log(this.db_name+'|Database:: Ready',this.db_tables);
    }
  }

  _setupDB()
  {
    let _this = this;
    return new Promise(function(resolve, reject) {

      // If we already have it use the cached one
      if (_this.db)
      {
        resolve();
      }
      else
      {
        _this.db = indexedDB.open(_this.db_name, _this.db_version);
        _this.db.onerror = function(event) {
          console.error(_this.db_name+'|Database::_setupDB '+event.target.errorCode+' Cannot open db '+_this.db_name ,event);
          reject(_this.db_name+'|Database::_setupDB '+event.target.errorCode+' Cannot open db '+_this.db_name);
        };
        _this.db.onupgradeneeded = function(event) {
          let db = event.target.result;
          console.debug(_this.db_name+'|Database::_setupDB Setting up ObjectStoreNames');
          var objectStore;
          // Check for objectStoreNames
          for(let objectStoreName in _this.db_tables)
          {
            objectStore = db.createObjectStore(objectStoreName, { keyPath: 'id', autoIncrement: false});
            console.debug(_this.db_name+'|Database::_setupDB Setting up objectStoreName: '+objectStoreName,_this.db_tables);
            if(('indexes' in _this.db_tables[objectStoreName]) &&  ('default' in _this.db_tables[objectStoreName]))
            {
              for(let i = 0; i < _this.db_tables[objectStoreName].indexes.length; i++)
              {
                let thisIndex = _this.db_tables[objectStoreName].indexes[i];
                if((thisIndex in _this.db_tables[objectStoreName].default) || (('generated_onupdate' in _this.db_tables[objectStoreName]) && (thisIndex in _this.db_tables[objectStoreName].generated_onupdate)))
                {
                  console.debug(_this.db_name+'|Database::_setupDB Adding index to'+objectStoreName+':'+thisIndex,_this.db_tables);
                  objectStore.createIndex(thisIndex, thisIndex, { unique: false });
                }
                else
                {
                  console.error(_this.db_name+'|Database::_setupDB Index '+thisIndex+' not in fields ' ,_this.db_tables);
                }
              }
            }
          }
        };

        // Fires once the database is opened (and onupgradeneeded completes, if
        // onupgradeneeded was called)
        _this.db.onsuccess = function(event) {
          // Set the db variable to our database so we can use it!
          _this.db = event.target.result;
          console.debug(_this.db_name+'|Database::_setupDB Setup done' );
          resolve();
        }
      }
    });
  }

  close()
  {
    this.db.close();
  }

  handles_table(name)
  {
    if(name in this.db_tables)
    {
      return true;
    }
    return false;
  }

  async upsert(objectStoreName, id, data={})
  {
    await this._setupDB();
    let _this = this;
    return new Promise((resolve, reject) => {
      try
      {
        if(_this.db)
        {
          var thisTransaction = _this.db.transaction(objectStoreName, "readwrite");
          let thisObjectStore = thisTransaction.objectStore(objectStoreName);
          data.id=id;
          if((objectStoreName in _this.db_tables) && ('generated_onupdate' in _this.db_tables[objectStoreName]))
          {
            for(let thisField in _this.db_tables[objectStoreName].generated_onupdate)
            {
              switch(_this.db_tables[objectStoreName].generated_onupdate[thisField])
              {
                case "date":
                  data[thisField] = Math.floor(+new Date() / 1000);
                  break;
                default:
                  break;
              }
            }
          }
          thisObjectStore.put(data);
          thisTransaction.oncomplete = function(event) {
            console.debug(_this.db_name+'|Database:: upsert /'+objectStoreName+'/'+id+' success',data);
            resolve(id);
          };
          thisTransaction.onerror = function(event) {
            reject('Error['+event.target.errorCode+'] Cannot PUT');
          }
        }
        else
        {
          throw "Missing database connection!";
        }
      }
      catch(ex)
      {
        console.error(_this.db_name+'|Database.upsert:: /'+objectStoreName+'/'+id,data ,ex);
        reject('error:'+_this.db_name+'|Database.upsert:: /'+objectStoreName+'/'+id);
      }
    });
  }

  async get(objectStoreName,query_type='all',query_value='next')
  {

    await this._setupDB();
    let _this = this;
    let sort='id';
    return new Promise((resolve, reject) => {

      try
      {
        if(_this.db)
        {
          var thisTransaction = _this.db.transaction(objectStoreName, "readonly");
          let thisObjectStore = thisTransaction.objectStore(objectStoreName);
          thisTransaction.onerror = function(event) {
            reject('thisTransactionError['+event.target.errorCode+'] Cannot GET');
          }

          let onerror = function(event) {
            reject('Error['+event.target.errorCode+'] Cannot GET');
          }
          var thisObjectStoreRequest = null;

          switch(query_type)
          {
            case "id":
              if(query_value.length<=0)
              {
                throw 'query_value<=0 please enter a query_value';
              }
              //thisObjectStore.index(sort);
              thisObjectStoreRequest = thisObjectStore.get(query_value);
              thisObjectStoreRequest.onerror=onerror;
              thisObjectStoreRequest.onsuccess = function(event) {
                console.debug(_this.db_name+'|Database:: get by '+objectStoreName+'/id ('+query_value+') success',event.target.result);
                resolve(event.target.result);
              };
              break;
            case "index":
              if(query_value.length<=0)
              {
                throw 'query_value<=0 please enter a query_value';
              }

              let theseIndexes = [];
              let theseIndexes_values = [];
              for(let anIndex in query_value)
              {
                theseIndexes.push(anIndex);
                theseIndexes_values.push(query_value[anIndex]);
              }

              if(theseIndexes.length == 1)
              {
                let thisObjectStoreIndex = thisObjectStore.index(theseIndexes[0]);
                var singleKeyRange = IDBKeyRange.only(theseIndexes_values[0]);
                let thisObjectStoreIndexCursor = thisObjectStoreIndex.openCursor(singleKeyRange);
                thisObjectStoreIndexCursor.onerror=onerror;
                let allResults = [];
                thisObjectStoreIndexCursor.onsuccess = function(event) {
                  var cursor = event.target.result;
                  if (cursor != null)
                  {
                    allResults.push(cursor.value);
                    cursor.continue();
                  }
                  else
                  {
                      console.debug(_this.db_name+'|Database:: get where '+objectStoreName+'/index ('+theseIndexes[0]+' = '+theseIndexes_values[0]+') success',allResults);
                      resolve(allResults);
                  }
                };
              }
              else
              {
                  throw 'Only one index is allowed not '+theseIndexes.length;
              }
              break;
            case "all":
              thisObjectStoreRequest = thisObjectStore.openCursor(null, query_value=='prev' ? 'prev' : 'next');
              thisObjectStoreRequest.onerror=onerror;
              let allResults = [];
              thisObjectStoreRequest.onsuccess = function(event) {
                let cursor = event.target.result;
                if (cursor != null) {
                  allResults.push(cursor.value);
                  cursor.continue();
                } else {
                  console.debug(_this.db_name+'|Database:: get '+objectStoreName+'/all ('+query_value+') success',allResults);
                  resolve(allResults);
                }
              }
              break;
            default:
              throw 'Unknown query_type='+query_type;
              break;
          }
        }
        else
        {
          throw "Missing database connection!";
        }
      }
      catch(ex)
      {
        console.error(_this.db_name+'|Database.get:: /'+objectStoreName+'/'+query_type+'/'+query_value ,ex);
        reject('error:'+_this.db_name+'|Database.get:: /'+objectStoreName+'/'+query_type+'/'+query_value);
      }
   });

  }
}


